<div class="carousel" role="region" [attr.aria-label]="alt || 'Project images'">
  <div
    class="slide-wrap"
    [class.slide-wrap--interactive]="images.length > 1"
    [attr.tabindex]="images.length > 1 ? 0 : -1"
    [attr.role]="images.length > 1 ? 'button' : null"
    [attr.aria-pressed]="images.length > 1 ? paused : null"
    [attr.aria-label]="
      images.length > 1
        ? (paused ? 'Play slideshow' : 'Pause slideshow')
        : null
    "
    (click)="togglePlayback()"
    (keydown)="onSlideKeydown($event)"
  >
    <img
      class="slide"
      [src]="images[index]"
      [alt]="alt ? alt + ' — image ' + (index + 1) + ' of ' + images.length : ''"
    />
    @if (images.length > 1) {
      <div class="playback-hint" aria-hidden="true">
        <mat-icon>{{ paused ? 'play_arrow' : 'pause' }}</mat-icon>
      </div>
    }
  </div>
  @if (images.length > 1) {
    <div class="controls">
      <button
        type="button"
        mat-icon-button
        class="nav prev"
        (click)="prev()"
        aria-label="Previous image"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <div class="dots" role="tablist" aria-label="Slide indicators">
        @for (url of images; track $index) {
          <button
            type="button"
            class="dot"
            [class.active]="$index === index"
            (click)="goTo($index)"
            [attr.aria-label]="'Image ' + ($index + 1)"
            [attr.aria-selected]="$index === index"
          ></button>
        }
      </div>
      <button
        type="button"
        mat-icon-button
        class="nav next"
        (click)="next()"
        aria-label="Next image"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  }
</div>
